import { ISelectorOption } from 'types/ISelectorOption';
import { styledSelect } from 'client/components/Form/Select/MenuListArrow';
import { SelectComponents } from 'react-select/src/components';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { updatePost } from 'client/_redux/actions/post';
import { getAllCategoryTours } from 'client/_redux/actions/categoryTour';
import { RootState } from 'client/_redux/reducers';
import IPostForm from 'client/models/IPostForm';
import { videoSpecOptions } from 'client/constants/videoSpecOptions';
import { useTranslation } from 'react-i18next';
import { useForm, SubmitHandler } from 'react-hook-form';

export const useVideoCardForm = (post: IPostForm) => {
  const component = styledSelect.components as Partial<
    SelectComponents<ISelectorOption, boolean>
  >;

  const formMethods = useForm<IPostForm>({ defaultValues: post });

  const { handleSubmit } = formMethods;

  const dispatch = useDispatch();

  const [t] = useTranslation();
  const { videoTypeOptions } = videoSpecOptions(t);

  const allCategoryTours = useSelector(
    (state: RootState) => state.categoryTour.allCategoryTours,
  );

  useEffect(() => {
    dispatch(getAllCategoryTours());
  }, [dispatch]);

  const parcourTypeOptions: ISelectorOption<string>[] = (
    allCategoryTours?.categoryTours || []
  ).map((cat) => ({
    label: cat.name,
    value: cat._id,
  }));

  const onSubmit: SubmitHandler<IPostForm> = (data) => {
    if (!post.postId) return;
    dispatch(updatePost(data, post.postId));
  };

  return {
    component,
    parcourTypeOptions,
    videoTypeOptions,
    t,
    formMethods,
    handleSubmit,
    onSubmit,
  };
};
